<template>
    <div>
        <div class="flex grow justify-center items-center" v-if="showListLoading">
            <activix-spinner
                class="sticky bottom-6 my-6"
                :style="{ top: `${containerOffsetHeight}px` }"
            />
        </div>

        <div v-else>
            <note-list-item
                :context-note-data="contextNoteData"
                :depth="depth"
                :highlighted-note-id="highlightedNoteId"
                :lead="lead"
                :last-in-group="index === lastNoteIndex"
                :note="note"
                :note-type-filter="noteTypeFilter"
                :readonly="readonly"
                :root-note-id="rootNoteId || note.id"
                :users="users"
                :variant="variant"
                :key="note.id"
                @trigger-deleting="$emit('trigger-deleting', $event)"
                @trigger-editing="$emit('trigger-editing', $event)"
                @trigger-replying="$emit('trigger-replying', $event)"
                v-for="(note, index) in notes"
            >
                <template #hover-actions="slotProps">
                    <slot name="hover-actions" v-bind="slotProps" />
                </template>
                <template #inline-editor="slotProps">
                    <slot name="inline-editor" v-bind="slotProps" />
                </template>
                <template #inline-reply="slotProps">
                    <slot name="inline-reply" v-bind="slotProps" />
                </template>
            </note-list-item>

            <div class="flex justify-center border-t p-3" v-if="showMoreItemsLoading">
                <activix-spinner :size="22" :line-size="2" />
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'pinia';
    import { useLayoutStore } from '@/store/modules/layout/store.js';

    import NoteListItem from '@/components/container/lead/notes/NoteListItem.vue';
    import { NoteListVariant } from '@/components/container/lead/notes/NoteListVariant.ts';
    import Lead from '@/entities/Lead.js';

    export default {
        components: {
            NoteListItem,
        },

        emits: ['trigger-deleting', 'trigger-editing', 'trigger-replying'],

        props: {
            contextNoteData: {
                type: Object,
                required: true,
            },
            depth: {
                type: Number,
                default: 0,
            },
            highlightedNoteId: {
                type: Number,
                default: null,
            },
            noteTypeFilter: {
                type: Array,
                default: () => [],
            },
            notes: {
                type: Array,
                required: true,
            },
            readonly: {
                type: Boolean,
                default: false,
            },
            rootNoteId: {
                type: Number,
                default: null,
            },
            showListLoading: {
                type: Boolean,
                default: false,
            },
            showMoreItemsLoading: {
                type: Boolean,
                default: false,
            },
            users: {
                type: Array,
                required: true,
            },
            lead: {
                type: Lead,
                required: true,
            },
            variant: {
                type: String,
                default: NoteListVariant.DEFAULT,
                validator: (value) => Object.values(NoteListVariant).includes(value),
            },
        },

        computed: {
            ...mapState(useLayoutStore, ['bodySpacingTop', 'headerHeight']),

            containerOffsetHeight() {
                return this.headerHeight + this.bodySpacingTop + 20;
            },

            lastNoteIndex() {
                return this.notes.length - 1;
            },
        },
    };
</script>
